import { Injectable } from '@angular/core';
import { NgwGame, NgwTeam, NgwPlayer, NgwRound, NgwPick, NgwScore } from '../app/classes/NgwGame';

@Injectable()
export class NgwScorerService {

    constructor() {
    }

    updateNextRoundWithPreviousRoundsStarting(round:NgwRound, game:NgwGame)
    {
        if(game.rounds.length >= round.num + 1)
        {
            var nextRound = game.rounds[round.num];
            nextRound.startingPot = round.carryOverToNextRoundPot;
            nextRound.totalPot = nextRound.totalPot + nextRound.startingPot;

        }
    }


    scoreGameOver(round:NgwRound, game:NgwGame)
    {
        this.unScoreRound(round, game);
       
        round.isScored = true;
        round.result = "No Winner > Game Over";
        round.carryOverToNextRoundPot = 0;

         //now go back any previous round that had carry overs, and call (scor with no carry Over)
        let currRoundNum = round.num - 1;
        while (currRoundNum >= 1 && game.rounds[currRoundNum - 1].carryOverToNextRoundPot) {
            let prevRound = game.rounds[currRoundNum - 1];
            if(prevRound.isScored)
            {
                this.scoreWithNoCarryOver(prevRound, game);
            }
            currRoundNum--;
        }

        this.updateNextRoundWithPreviousRoundsStarting(round, game)
    }

    scoreWithCarryOver(round:NgwRound, game:NgwGame)
    {
        this.unScoreRound(round, game);
      
       //populate the scoredPlayerPoints with everyone playing
        round.scoredPlayerPoints = [];
         game.players.forEach((player) => {
             round.scoredPlayerPoints.push({
                 player: player,
                 pts: 0
             });            
        })

        var roundTotal = 0;
        //Go through every pick and apply negative to that user
        round.picks.forEach((pick:NgwPick) => {
            
                round.scoredPlayerPoints.forEach((score:any) => {
                    if(score.player.name == pick.ngwPlayer.name)
                    {
                        score.pts = score.pts - 1;
                        roundTotal++;                
                    }                    
                });
            
        })

        round.isScored = true;
        round.result = "No Winner > Pot Carried Over";
        round.carryOverToNextRoundPot = roundTotal + round.startingPot;
        this.updateNextRoundWithPreviousRoundsStarting(round, game)
    }

    scoreWithNoCarryOver(round:NgwRound, game:NgwGame)
    {
        this.unScoreRound(round, game);
       
        round.isScored = true;
        round.result = "No Winner > Pot Returned";
        round.carryOverToNextRoundPot = 0;
        this.updateNextRoundWithPreviousRoundsStarting(round, game)
    }


    scoreWithNoCarryOverButCarryPicks(round:NgwRound, game:NgwGame)
    {
        this.unScoreRound(round, game);
       
        round.isScored = true;
        round.result = "No Winner > Picks Carried Over";
        round.carryOverToNextRoundPot = 0;
        this.updateNextRoundWithPreviousRoundsStarting(round, game)
    }

    scoreWithWinner(round:NgwRound, game:NgwGame, winningPlayer:NgwPlayer)
    {
        this.unScoreRound(round, game);

        //populate the scoredPlayerPoints with everyone playing
        round.scoredPlayerPoints = [];
         game.players.forEach((player) => {
             round.scoredPlayerPoints.push({
                 player: player,
                 pts: 0
             });            
        })

        var roundTotal = 0;
        //Go through every pick and apply negative to that user
        round.picks.forEach((pick:NgwPick) => {
            if(pick.ngwPlayer.name != winningPlayer.name)
            {
                round.scoredPlayerPoints.forEach((score:any) => {
                    if(score.player.name == pick.ngwPlayer.name)
                    {
                        score.pts = score.pts - 1;
                        roundTotal++;                
                    }                    
                });
            }
        })

        //now go back any previous round that had carry overs, and add  those round's scoredPlayerPoints with this round'score
        let currRoundNum = round.num - 1;
        while (currRoundNum >= 1 && game.rounds[currRoundNum - 1].carryOverToNextRoundPot) {
            let prevRound = game.rounds[currRoundNum - 1];
            if (prevRound.isScored) {
                round.scoredPlayerPoints.forEach((score: any) => {
                    if (score.player.name != winningPlayer.name) {
                        prevRound.scoredPlayerPoints.forEach((prevScore: any) => {
                            if (score.player.name == prevScore.player.name) {
                                score.pts = score.pts + prevScore.pts;
                                roundTotal = roundTotal + (prevScore.pts * -1);
                            }
                        })
                    }
                });
            }
            currRoundNum--;
        }

        //Now apply that total as positive to the winner 
        round.scoredPlayerPoints.forEach((score: any) => {
            if (score.player.name == winningPlayer.name) {
                score.pts = score.pts + roundTotal;
            }
        });

        this.updatePlayerBalances(game, round.scoredPlayerPoints, false);

        round.isScored = true;
        round.result = winningPlayer.name + " Won";
        round.carryOverToNextRoundPot = 0;
        this.updateNextRoundWithPreviousRoundsStarting(round, game)
    }

    updatePlayerBalances(game: NgwGame, scoredPlayerPoints: any[], unScore: Boolean) {

        scoredPlayerPoints.forEach((score: any) => {
            let player = this.findPlayer(score.player.name, game);
            if (player) {
                if(typeof(player.balance) == "undefined")
                    player.balance = 0;
                if (unScore)
                    player.balance = player.balance - score.pts;
                else
                    player.balance = player.balance + score.pts;
            }
        });
    }

    unScoreRound(round:NgwRound, game:NgwGame)
    {
        if(round.isScored)
        {
            if(round.scoredPlayerPoints)
                this.updatePlayerBalances(game, round.scoredPlayerPoints, true);            

            round.isScored = false;
            round.result = "Open"
            round.scoredPlayerPoints = [];
            //Change the next round's pot:
            if(game.rounds.length >= round.num + 1)
            {
                var nextRound = game.rounds[round.num];
                nextRound.totalPot = nextRound.totalPot - nextRound.startingPot;
                nextRound.startingPot = 0;
            }
        }
    }

    findPlayer(name:string, game:NgwGame):NgwPlayer {
        for(var i = 0; i < game.players.length; i++)
        {
            var player = game.players[i];
             if(player.name == name)
                return player;
        }
      
        return null;
    }

}


// WEBPACK FOOTER //
// ./src/app/ngwScorer.service.ts